export default {
  USER_EXIST: 31,
  PROMOTION_CODE_INVALID: 21,
};
